import { userRepository } from "src/features/users/repositories/user.repository";
import { FilterSessionsInputs, SessionsFilter } from "../types";

export const buildSessionsFilter = async (where: FilterSessionsInputs): Promise<SessionsFilter> => {
  const filter: SessionsFilter = {};

  const [coachUser, learnerUser] = await Promise.all([
    where.coachIdentifier ? userRepository.getByUnique(where.coachIdentifier) : Promise.resolve(null),
    where.learnerIdentifier ? userRepository.getByUnique(where.learnerIdentifier) : Promise.resolve(null),
  ]);

  if (coachUser && coachUser.roles?.includes("COACH")) {
    filter.coachId = coachUser.id;
  }

  if (learnerUser && learnerUser.roles?.includes("LEARNER")) {
    // For learner filtering, we need to use array-contains since learnerIds is an array
    (filter as any).learnerIds = { $arrayContains: [learnerUser.id] };
  }

  return {
    ...filter,
    ...(where.id ? { id: where.id } : {}),
    ...(where.currency ? { currency: where.currency } : {}),
    ...(where.type ? { type: where.type } : {}),
    ...(where.state ? { state: where.state } : {}),
    ...(where.langCode ? { langCode: where.langCode } : {}),
  };
};
